import { render, staticRenderFns } from "./HTMLEditor.vue?vue&type=template&id=58a47308"
import script from "./HTMLEditor.vue?vue&type=script&lang=js"
export * from "./HTMLEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a47308')) {
      api.createRecord('58a47308', component.options)
    } else {
      api.reload('58a47308', component.options)
    }
    module.hot.accept("./HTMLEditor.vue?vue&type=template&id=58a47308", function () {
      api.rerender('58a47308', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HTMLEditor.vue"
export default component.exports